import type { Draft, WritableDraft } from 'immer/dist/internal';
import { omit, pull } from 'lodash';

import type { MarketId, MarketTemplate, MarketView } from '@swf/generated/types/api/sports';
import { isCompoundMarketTemplate } from '@swf/sports/utils/isCompoundMarketTemplate';

interface GenericMarketTemplate {
  markets: Partial<Record<MarketId, MarketView>>;
  groups: {
    templates: MarketTemplate[];
  }[];
}

const removeClosedMarketsFromTemplates = <T extends GenericMarketTemplate>(
  data: WritableDraft<T>,
  closed: string[]
) => {
  data.markets = omit(data.markets, closed) as Draft<T['markets']>;

  data.groups = data.groups.filter((group) => {
    group.templates = group.templates.filter((template) => {
      if (isCompoundMarketTemplate(template)) {
        template.marketIds = pull(template.marketIds, ...closed);

        return Boolean(template.marketIds.length);
      }

      return !closed.includes(template.marketId);
    });

    return Boolean(group.templates.length);
  }) as Draft<T['groups']>;
};

export default removeClosedMarketsFromTemplates;
